/**
 * Moved to `@sizzlenz/shared-frontend/hooks`.
 * Re-exported here so existing `@/lib/hooks/useSiteSettings` imports keep working.
 */
export {
  useSiteSettings,
  useSiteSetting,
  getEnvironmentSiteSettingsOverrides,
} from '@sizzlenz/shared-frontend/hooks';
